import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import './index.css'

// Crear instancia de QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
})

// Nota: La interceptación de /auth/* se maneja en index.html (script inline)
// que se ejecuta ANTES de que React se cargue. Este archivo solo monta React.

// Filtrar errores de extensiones del navegador que no afectan la aplicación
const extensionErrorPatterns = [
  'message channel closed',
  'asynchronous response',
  'A listener indicated an asynchronous response',
  'Extension context invalidated',
  'Receiving end does not exist',
  'returning true, but the message channel closed'
]

const originalError = window.console.error
window.console.error = (...args) => {
  const errorMessage = args.join(' ')
  if (extensionErrorPatterns.some(p => errorMessage.includes(p))) return
  originalError.apply(console, args)
}

// Manejar errores no capturados de promesas (registrar ANTES de que React se cargue)
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || String(event.reason || '')
  if (extensionErrorPatterns.some(p => errorMessage.includes(p))) {
    event.preventDefault()
    event.stopImmediatePropagation()
    return false
  }
}, true)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)